import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderGlobal from "../../components/Header/HeaderGlobal/index.js";
import LogoutModal from "../../components/Header/LogoutModal/index.js";
import NavigationItems from "../../components/Header/NavigationItems/index.js";
import {
    Header,
    HeaderContainer,
    HeaderName,
    SkipToContent,
} from '@carbon/react';
import { 
    addModal, 
    closeModal, 
    toggleModal, 
    selectModals, 
    selectWrittenNavigationItems, 
    setActiveNavItem, 
    setNavItemVisibility
} from "../../features/application/applicationSlice.js";
import { logoutThunk, profileRequestThunk } from "../../features/user/userThunks.js";
import { selectUserIsAdmin, selectUserProfile, selectUser } from "../../features/user/userSlice.js";
import { getModalById } from "../../utils/modalUtils.js";

const HeaderLayout = () => {
    const navigator = useNavigate();
    const location = useLocation()
    const dispatch = useDispatch()
    const dispatchLogout = () => {
        dispatch(closeModal(modalLogout))
        dispatch(logoutThunk())
    }
    const user = useSelector(selectUser)
    const isAdmin = useSelector(selectUserIsAdmin)
    const userProfile = useSelector(selectUserProfile)
    const modal = useSelector(selectModals)
    const navItems = useSelector(selectWrittenNavigationItems)
    const modalLogout = 'logout'

    useEffect(() => {
        dispatch(addModal(modalLogout))
    }, [dispatch])

    useEffect(() => {
        if (user.token_access && !userProfile?.user) {
            dispatch(profileRequestThunk())
        }
    }, [user.token_access, userProfile?.user, dispatch])

    useEffect(() => {
        dispatch(setNavItemVisibility({ item: 'admin', active: isAdmin }))
    }, [isAdmin, dispatch])

    useEffect(() => {
        const pathToItemMap = {
            '/dashboard': 'dashboard',
            '/telemetry': 'telemetry',
            '/profile': 'profile',
            '/notifications': 'notifications',
            '/login': 'login'
        }
        
        const item = pathToItemMap[location.pathname]
        if (item) {
            dispatch(setActiveNavItem({ item }))
        }
    }, [location.pathname, dispatch])

    const redirectTo = (item) => {
        if (item.target === 'in') {
            navigator(item.url)
        } else {
            window.location.href = `${window.location.origin}${item.url}`
        }
    }

    const highlightElement = (item_name) => {
        const activeItem = navItems.find(item => item.name === item_name && item.now === true)
        if (activeItem) {
            return <span className="nav-active"><strong><u>{item_name}</u></strong></span>
        }
        return <span>{item_name}</span>
    }
    if (location.pathname !== '/' && location.pathname !== '/login') {
        return (
            <HeaderContainer
                render={() => (
                    <Header aria-label="MAKEMAKE">
                        <SkipToContent />
                        <HeaderName className="pointer" onClick={() => {
                            navigator('/dashboard')
                        }} prefix="MAKEMAKE">
                            <span className={'subtitle'}>Data Analysis Tool</span>
                        </HeaderName>
                        <NavigationItems 
                            onItemClick={redirectTo} 
                            highlightElement={highlightElement} 
                        />
                        <HeaderGlobal 
                            onProfileClick={redirectTo} 
                            onNotificationsClick={redirectTo} 
                            onLogoutClick={() => dispatch(toggleModal(modalLogout))} 
                        />
                        <LogoutModal 
                            isOpen={getModalById(modal, modalLogout) ? getModalById(modal, modalLogout).state : false}
                            onClose={() => dispatch(closeModal(modalLogout))}
                            onLogout={dispatchLogout}
                        />
                    </Header>)}
            />
        )
    }
    else {
        return (
            <HeaderContainer
                render={() => (
                    <Header aria-label="MAKEMAKE">
                        <SkipToContent />
                        <HeaderName className="pointer" onClick={() => {
                            navigator('/login')
                        }} prefix="MAKEMAKE">
                            <span className={'subtitle'}>Data Analysis Tool</span>
                        </HeaderName>
                    </Header>)}
            />
        )
    }
}
export default HeaderLayout
